import { action } from 'lib/actions';

export const removeSelectedAction = action('selectedItemsControls/DELETE');
export const shareSelectedAction = action('selectedItemsControls/SHARE');
